import React from 'react'
import PropTypes from 'prop-types'
import { Modal, Button } from 'react-bootstrap'

import './rate-limit-modal.css'

class RateLimitModal extends React.Component {
  constructor (props) {
    super(props)
    this.state = {}
  }

  render () {
    const { showModal, hideModal, handleAccept } = this.props

    return (
      <Modal show={showModal} onHide={hideModal}>
        <Modal.Body>
          <div className='br-proceed-upload'>
            <span
              className='glyphicon glyphicon-exclamation-sign'
              aria-hidden='true'
            />
            <div style={{ marginTop: ' 20px' }}>
              This requires that you already have permission from Twitter
              <br />
              to increase the limit.
            </div>
            <div>
              <h4>Do you have permission for this handle?</h4>
            </div>
            <div>
              <Button className='btn green-haze' onClick={handleAccept}>
                Yes
              </Button>
              <Button className='btn red-haze' onClick={hideModal}>
                No
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    )
  }
}

RateLimitModal.propTypes = {
  showModal: PropTypes.bool,
  hideModal: PropTypes.func,
  handleAccept: PropTypes.func
}

export default RateLimitModal



// WEBPACK FOOTER //
// ./src/pages/widgets/form/configure-rate-limits/components/rate-limit-modal/index.js